import React from 'react'
import { getSchoolNameFromAbbreviation } from '../../../api';
import { GuitarPlayerSVG } from './GuitarPlayerSVG';
import './confirmation-page.css'
const ConfirmationPage = ({family, school}) => {
    const [website, setWebsite] = React.useState('')
    const [schoolName, setSchoolName] = React.useState('')

    React.useEffect(() => {
        if(school?.schoolAbbreviation) {
            setWebsite(createWebsiteLink(school))
            setSchoolName(getSchoolNameFromAbbreviation(school.schoolAbbreviation))
        }
    }, [school])

    const createWebsiteLink = (school) => {
        switch (school.schoolAbbreviation.toLowerCase()) {
            case "mma":
                return "https://www.mountainsidemusicacademy.com/music-teachers-in-boulder";
            case "lsma":
                return "https://www.lakesidemusicacademy.com/our-teachers";
            case "tma":
                return "https://www.treesidemusicacademy.com/our-teachers";
            case "tsma":
                return "https://www.treesidemusicacademy.com/our-teachers";
            case "mor":
                return "https://www.morningsidemusicacademy.com/our-teachers";
            case "psma":
                return "https://www.parksidemusicacademy.com/our-teachers";
            default:
                return null
        }
    }
    return(
        <div className="confirmation-page__wrapper">
            <div className='confirmation-page__text'>Nice! You have added {family?.students.length} {family?.students.length > 1 ? 'students' : 'student'} to {schoolName}.</div>
            <div className='confirmation-page__svg'>
                <GuitarPlayerSVG />
            </div>
            {website && <a className='confirmation-page__teacher-link' href={website}>Meet Our Teachers</a>}
        </div>
    )
}
export default ConfirmationPage;